
      var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPlaylistIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  height: 20,
  width: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  stroke: "var(--theme-primary, #810ea9)",
  viewBox: "2.25 5.25 19.5 14.5"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M15 6H3M13 10H3M9 14H3M8 18H3M17 16.5V8",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 14.5,
  cy: 16.5,
  r: 2.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M21 12a4 4 0 0 1-4-4",
  strokeLinecap: "round"
}))));

      const __svgRaw = "<svg height=\"20\" width=\"24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" stroke=\"var(--theme-primary, #810ea9)\" viewBox=\"2.25 5.25 19.5 14.5\">   <g stroke-width=\"0\"></g>   <g stroke-linecap=\"round\" stroke-linejoin=\"round\"></g>   <g>      <path d=\"M15 6L3 6\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"1.5\" stroke-linecap=\"round\"></path>      <path d=\"M13 10L3 10\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"1.5\" stroke-linecap=\"round\"></path>      <path d=\"M9 14H3\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"1.5\" stroke-linecap=\"round\"></path>      <path d=\"M8 18H3\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"1.5\" stroke-linecap=\"round\"></path>      <path d=\"M17 16.5V12.5V8\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"1.5\" stroke-linecap=\"round\"></path>      <circle cx=\"14.5\" cy=\"16.5\" r=\"2.5\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"1.5\"></circle>      <path d=\"M21 12C18.7909 12 17 10.2091 17 8\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"1.5\" stroke-linecap=\"round\"></path>    </g> \r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/playlistIcon.535e2c6ec1cf43bde283e6d123d0c7f1.svg"),
        {
          React: SvgPlaylistIcon,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      